import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  // Send/receive the httpOnly auth cookie on every request.
  withCredentials: true,
  // Never let a request hang forever (e.g. backend down/slow). Bounds the
  // boot /auth/me call and every data fetch so the UI can recover instead of
  // showing an infinite spinner. Long uploads can override per-call.
  timeout: Number(process.env.REACT_APP_API_TIMEOUT_MS) || 20000,
});

// Global session handling: when the server says the session is gone (401),
// clear client auth state and bounce to login — but only from protected
// (/dashboard) pages, so public/auth pages don't loop or flash.
API.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      const path = window.location.pathname;
      const onAuthPage = /^\/(login|signup|doctor-login|register-doctor|pharmacy-login|pharmacy-signup|insurer-login|admin-login|forgot-password|reset-password)/.test(path);
      if (path.startsWith("/dashboard") && !onAuthPage) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);

export default API;
